<template lang="html">
  <div class="latest-product container border my-5 py-5">
    <h2 class="text-uppercase text-dark h1 text-center font-weight-bold">latest roduct</h2>
    <h3 class="text-uppercase text-center d-table rounded mx-auto p-1 badge-primary h5">so you get to know me better</h3>
    <Loading v-if="!products.length"/>
    <div class="row p-1 d-flex align-ittems-center justify-content-center">
      <Product v-for="p in products" :product="p" :key="p.id"/>
    </div>
  </div>
</template>

<script>
import Product from './Product.vue'
import Loading from '../assets/Loading.vue'

export default {
  data(){
    return {
      products: []
    };
  },
  components:{
    Product,
    Loading
  },
  computed:{
    api(){
      return this.$store.state.api
    }
  },
  mounted(){
    fetch(`${this.api}/index/product`)
    .then(res => res.json())
    .then(data => {
      if(data.success) this.products = data.data.sort((a, b)=> b.id - a.id).slice(0,4);
    }).catch(err => console.log(err))
  }
}
</script>

<style lang="css" scoped>
.latest-product{
  background: #FFF;
}
</style>
